<div class="form-container">
  <h2>Creación de contrato de forma masiva</h2>
  <div class="section">
    <h3 class="section-title">Plantilla</h3>
    <div class="form-row">
      <button class="btn" (click)="descargarPlantilla()">Descargar plantilla</button>
      <span class="info-icon"
        title="Plantilla que debera llenar con todos los campos correspondientes de forma sucesiva y debera guardar con extension .csv para la generacion masiva.">ℹ️</span>
    </div>
  </div>

  <div class="divider"></div>
  <div class="section">
    <h3 class="section-title">Cargue de documento</h3>
    <div class="form-row">
      <input type="file" id="fileInput" (change)="validarArchivo($event)" hidden />
      <label for="fileInput" class="btn">Cargar la plantilla con información</label>
      <span *ngIf="archivoValido !== null" [class]="archivoValido ? 'icon-valid' : 'icon-invalid'">
        {{ archivoValido ? '✔️' : '❌' }}
      </span>
    </div>
  </div>

  <div class="template-selector">
    <h3>Selecciona una plantilla</h3>
    <div class="template-options">
      <label *ngFor="let template of templates">
        <input type="radio" name="template" [value]="template.id" [(ngModel)]="selectedTemplate" required />
        <span class="template-icon" [class.selected]="selectedTemplate === template.id">
          {{ template.icon }} {{ template.name }}
        </span>
      </label>
    </div>
  </div>

  <div class="divider"></div>
  <div class="form-actions">
    <button class="btn btn-generate" [disabled]="!isFormularioValido()" (click)="generarContrato()">Generar</button>
  </div>
</div>